
import { computed, defineComponent } from "vue";
import MiddleHeader from "@/components/MiddleHeader.vue";
import EditDataThumbnail from "@/components/EditDataThumbnail.vue";
import store from "@/stores";
import { makeTemplateSet, makeNoImageTemplateSet } from "@/services/Models";

export default defineComponent({
  name: "SelectEditData",
  components: {
    MiddleHeader,
    EditDataThumbnail,
  },
  setup() {
    const resource = store.useResource();
    // 編集データの一覧
    const saveDatas = computed(() => {
      return resource.data.editDatas.map((editData) => {
        let template;
        if (!editData.templateID) {
          // テンプレートIDなし(コマ入れ替えあり)はITemplateSetを生成する
          template = makeTemplateSet(editData, resource.data.templateSets);
        } else {
          template = resource.data.templateSets.find(
            (x) => x.id == editData.templateID
          );

          if (template === undefined || template.frames.length !== 4) {
            // テンプレートが検索できない、または4コマ分のテンプレートがなければテンプレートなし(削除されたテンプレートとして固定画像表示)
            template = makeNoImageTemplateSet();
          }
        }
        return [template, editData];
      });
    });

    return {
      saveDatas,
    };
  },
});
